import styled from 'styled-components';

export default styled.header`
  z-index: 8;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 12px;
  height: 60px;
  min-height: 60px;
  width: 100%;
  box-sizing: border-box;
  background: ${(props) => props.theme['color.surface']};
  box-shadow: ${(props) => props.theme['shadow.nav']};

  & > *:not(:last-child) {
    margin-right: 12px;
  }
`;
